import React, { Component } from 'react';
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { updateGame } from "../../actions/index";

/**
 * Goes inside a modal to update just the intro text.
 */
class UpdateIntro extends Component {

    static renderArea(reduxField) {
        const { input, label, placeholder, type, meta: { touched, error, warning } } = reduxField;
        const className = `form-group ${touched && error ? 'has-danger' : ''}`;

        return (
            <div className={className}>
                <label>{label}</label>
                <textarea
                    className="form-control"
                    type={type}
                    placeholder={placeholder}
                    rows="6" cols="60"
                    {...input}
                >
                </textarea>
                {touched &&
                ((error && <span className="text-danger">{error}</span>) ||
                    (warning && <span>{warning}</span>))}
            </div>
        );
    }

    onSubmit(values) {

        const { game, closeModalCallback } = this.props;

        this.props.updateGame(game.id, game.isPublic, values, () => {
            closeModalCallback();
        });
    }

    render() {
        const { handleSubmit } = this.props;

        const noTopPadding = {
            paddingTop: '0px'
        };

        return (
            <div>
                <button
                    style={noTopPadding}
                    className="btn btn-link pull-right"
                    onClick={this.props.closeModalCallback}>

                    X
                </button>
                <h5> Introduction </h5>
                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                    <div>
                        <div>
                            <div>
                                {/*<input type="textarea" name="intro" value={currentText}/>*/}
                                <Field name="intro" component={UpdateIntro.renderArea} />
                            </div>
                        </div>
                        <div>
                            <button type="submit">
                                Save
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
UpdateIntro = reduxForm({
    form: 'UpdateIntroForm' // a unique identifier for this form
})(
    connect(null, { updateGame }
    )(UpdateIntro));

// You have to connect() to any reducers that you wish to connect to yourself

UpdateIntro = connect(
    state => {
        const selectedGame = state.games[state.selectedGameId];

        return {
            initialValues: {
                intro: selectedGame.intro
            },
            game: selectedGame
        }
    }
)(UpdateIntro);

export default UpdateIntro;



// WEBPACK FOOTER //
// ./src/components/huntcomponents/UpdateIntro.js